import { useTranslation } from 'react-i18next';
import {
  CardCoupon,
  CardTitle,
  CardWrapper,
  Circle1,
  Circle2,
  Circle3,
  Circle4,
} from './CouponCard.styles';
import { couponCard } from './CouponCard.types';

const CouponCard = ({ couponCode }: couponCard) => {
  const { t } = useTranslation();
  return (
    <CardWrapper>
      <Circle1 />
      <Circle2 />
      <Circle3 />
      <Circle4 />
      <CardTitle>{t('yourcodeis')}</CardTitle>
      <CardCoupon>{couponCode && couponCode}</CardCoupon>
    </CardWrapper>
  );
};

export default CouponCard;
